import { LinearProgress, Stack, Typography } from "@mui/material"
import { motion } from "framer-motion"
import React from "react"

import { Agent } from "./Agent"
import { AgentFlow } from "./AgentFlow"
import { Botega } from "./Botega"
import { BotegaFlow } from "./BotegaFlow"
import { Dexi } from "./Dexi"
import { NumberFont } from "../../theme"

export type CreateAgentStage =
  | "spawning"
  | "connecting"
  | "receiving"
  | "finalizing"
  | "top-up"
  | "done"

const STAGE_TITLES: Record<CreateAgentStage, string> = {
  spawning: "Agent Spawning",
  "top-up": "Agent Topping Up",
  connecting: "Agent Registering with Dexi",
  receiving: "Agent Receiving Data",
  finalizing: "Agent Finalizing Connection",
  done: "Agent Ready",
}

const STAGE_PROGRESS: Record<CreateAgentStage, number> = {
  spawning: 0,
  "top-up": 25,
  connecting: 50,
  receiving: 75,
  finalizing: 100,
  done: 100,
}

export function CreateAgentAnimation(props: { stage: CreateAgentStage }) {
  const { stage } = props

  return (
    <>
      <Stack
        width="fit-content"
        gap={0.5}
        alignItems="center"
        sx={{
          transform: { xs: "scale(0.5)", md: "scale(1)" },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          // sx={{ border: "1px solid red" }}
          component={motion.div}
          initial="rest"
          animate={stage}
        >
          <Botega animate={STAGE_PROGRESS[stage] >= 75 ? "show" : "rest"} />
          <BotegaFlow animate={STAGE_PROGRESS[stage] >= 75 ? "show" : "rest"} />
          <Agent animate={STAGE_PROGRESS[stage] >= 25 ? "show" : "spawning"} initial="rest" />
          <AgentFlow animate={STAGE_PROGRESS[stage] >= 50 ? "show" : "rest"} />
          <Dexi animate={STAGE_PROGRESS[stage] >= 50 ? "show" : "rest"} />
        </Stack>
        {stage !== "done" && (
          <>
            <LinearProgress
              value={STAGE_PROGRESS[stage]}
              color="accent"
              variant="determinate"
              sx={{
                width: "100%",
                height: 25,
                borderRadius: 0.375,
                backgroundColor: "var(--mui-palette-background-paper)",
                border: "1px solid var(--mui-palette-borderSecondary)",
              }}
            />
            <Typography variant="h6" fontWeight={300}>
              {STAGE_TITLES[stage]}{" "}
              <Typography
                variant="inherit"
                component="span"
                fontWeight={500}
                fontFamily={NumberFont}
              >
                {STAGE_PROGRESS[stage]}%
              </Typography>
            </Typography>
            {/* <Typography
              color="secondary"
              variant="caption"
              sx={{ textTransform: "uppercase" }}
              fontFamily={NumberFont}
            >
              // Retrieving
            </Typography> */}
          </>
        )}
      </Stack>
    </>
  )
}
